module.exports = __webpack_public_path__ + "../resources/img/prod_detail_img.f593f106.png";